<h2 mat-dialog-title>{{ isCancel ? 'Cancel repeating appointment' : 'Edit repeating appointment' }}</h2>

<mat-dialog-content>
  @if (data.summary) {
    <p class="scope-summary">{{ data.summary }}</p>
  }

  <p class="scope-question">
    {{ isCancel ? 'Which appointments should be cancelled?' : 'Which appointments should this change apply to?' }}
  </p>

  <mat-radio-group [(ngModel)]="scope" class="scope-options">
    <mat-radio-button value="This">This appointment only</mat-radio-button>
    <mat-radio-button value="ThisAndFollowing">This and all later appointments</mat-radio-button>
  </mat-radio-group>

  <p class="scope-note">
    Appointments before this one are never changed — they are a record of time that was
    actually blocked out.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="dismiss()">Back</button>
  <button mat-flat-button color="primary" type="button" (click)="confirm()">
    {{ isCancel ? 'Cancel appointments' : 'Continue' }}
  </button>
</mat-dialog-actions>
